var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{ref:"parent-height",staticClass:"fill-height",attrs:{"flat":"","color":"transparent"}},[_c('data-table-shared',{attrs:{"headers":_vm.headers,"items":_vm.items,"height":_vm.fixedHeight,"perPage":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }